// extracted by mini-css-extract-plugin
export default {"patientItem":"BookingSelectPatients_patientItem__b8+7w","patientItemDetails":"BookingSelectPatients_patientItemDetails__Tedyt"};